// Regra do título de etiqueta (#1278). Espelha `RegexHelper::LABEL_TITLE_REGEX`
// (lib/regex_helper.rb) e `Labels::TitleNormalizer` — se um lado mudar, o outro
// muda junto, senão a mesma etiqueta digitada aqui e enviada pela API vira duas.
//
// Aceita letras com acento, números, espaço e `_ - . & + ( ) ' ! : ; @ *`,
// começando por letra ou número. Ficam de fora a vírgula (separador do
// acts-as-taggable-on), `/ ? #` (URL do painel) e `%` (curinga do LIKE).
export const LABEL_TITLE_PATTERN =
  /^[\p{L}\p{N}][\p{L}\p{M}\p{N} _\-.&+()'!:;@*]*[\p{L}\p{M}\p{N}_\-.&+()'!:;@*]$/u;
export const labelSanitizePattern = /[^\p{L}\p{M}\p{N} _\-.&+()'!:;@*]/gu;
export const spacesPattern = /\s+/g;
const leadingPunctuationPattern = /^[^\p{L}\p{N}]+/u;

/**
 * O que o backend faz antes de validar (`Label.normalize_title`): NFC, espaço
 * das pontas e duplicado, minúsculas. Não remove caractere nenhum.
 *
 * @param {string | undefined | null} label
 * @returns {string}
 */
export const normalizeLabelTitle = (label = '') => {
  if (!label) return '';

  return String(label)
    .normalize('NFC')
    .replace(spacesPattern, ' ')
    .trim()
    .toLowerCase();
};

/**
 * Normaliza o título e remove os caracteres que o backend recusa. Acento e
 * espaço sobrevivem.
 *
 * @param {string | undefined | null} label - The label to sanitize.
 * @returns {string} The sanitized label.
 *
 * @example
 * sanitizeLabel('  São   Paulo, 50% '); // 'são paulo 50'
 */
export const sanitizeLabel = (label = '') => {
  if (!label) return '';

  return normalizeLabelTitle(
    normalizeLabelTitle(label).replace(labelSanitizePattern, '')
  ).replace(leadingPunctuationPattern, '');
};

/**
 * Busca direta por título: o que o usuário digitou (já sanitizado) aparece
 * dentro do título sanitizado. Existe porque o picoSearch devolve `[]` para
 * qualquer consulta com espaço, mesmo igual ao título (#1278).
 *
 * @param {string} title - Título da etiqueta.
 * @param {string} search - Consulta crua digitada.
 * @returns {boolean}
 */
export const labelTitleIncludes = (title, search) => {
  const query = sanitizeLabel(search);
  if (!query) return false;

  return sanitizeLabel(title).includes(query);
};
